import { useEffect } from 'react';
import { Platform } from 'react-native';
import { activateKeepAwakeAsync, deactivateKeepAwake } from 'expo-keep-awake';
import { useUIStore } from '@/store/ui';

const IS_PHONE = Platform.OS === 'ios' || Platform.OS === 'android';

/** True when the native keep-awake lock should be held. Missing/legacy values stay on. */
export function isKeepScreenAwakeEnabled(keepScreenAwake) {
  return keepScreenAwake !== false;
}

/**
 * Keep the phone screen awake while Gab AI is in the foreground, unless the
 * user has turned that off in settings. Auto-lock resumes on background.
 */
export default function useKeepScreenAwake() {
  const enabled = useUIStore((state) => (
    IS_PHONE && isKeepScreenAwakeEnabled(state.keepScreenAwake)
  ));

  useEffect(() => {
    if (!IS_PHONE || !enabled) return undefined;
    activateKeepAwakeAsync().catch(() => {});
    return () => deactivateKeepAwake();
  }, [enabled]);
}
